import React from "react"
import PropTypes from "prop-types"
import MapBrowser from "../map/MapBrowser"

export default class EmergencyMap extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      circles: [],
      lat: props.defaultLat,
      long: props.defaultLong,
    };
    this.handleClick = this.handleClick.bind(this);
    this.handleLocationFound = this.handleLocationFound.bind(this);
  }

  componentDidMount() {
    // 初期値がある場合はマーカー(円)を表示
    if (this.props.defaultLat && this.props.defaultLong) {
      this.updateMarker(this.props.defaultLat, this.props.defaultLong);
    }
  }

  handleClick(e) {
    const lat = e.latlng.lat;
    const long = e.latlng.lng;
    this.updateMarker(lat, long);
    this.updateFormFields(lat, long);
  }

  handleLocationFound(lat, long) {
    this.updateMarker(lat, long);
    this.updateFormFields(lat, long);
  }

  updateMarker(lat, long) {
    const newCircle = {
      vertexes: {
        center: { lat: lat, lng: long },
        radius: 20 // 20m radius circle as marker
      },
      color_code: "#FF0000", // Red
      name: "発生場所"
    };

    this.setState({
      lat: lat,
      long: long,
      circles: [newCircle]
    });
  }

  updateFormFields(lat, long) {
    // Railsのフォームのhidden fieldを更新
    const latInput = document.getElementById('emergency_lat');
    const longInput = document.getElementById('emergency_long');

    if (latInput) latInput.value = lat;
    if (longInput) longInput.value = long;
  }

  render() {
    return (
      <div style={{ height: "500px", width: "100%" }}>
        <MapBrowser
          center={this.props.center}
          zoom={15}
          height={'500px'}
          handleClick={this.handleClick}
          onLocationFound={this.handleLocationFound}
          circles={this.props.circles} // 既存の円 (ジオフェンス)
          formcircles={this.state.circles} // ユーザーが追加・操作する円
          lines={this.props.lines}
          polygons={this.props.polygons}
          vbuoys={this.props.vbuoys}
          geojsons={this.props.geojsons}
          emergencies={[]}
          measure_distance={false}
          show_label={true}
          showPins={true}
          organization_id={this.props.organization_id}
          mapboxOption={this.props.mapboxOption}
          mapboxAccessToken={this.props.mapboxAccessToken}
        />
      </div>
    );
  }
}

EmergencyMap.propTypes = {
  center: PropTypes.array,
  organization_id: PropTypes.number,
  defaultLat: PropTypes.number,
  defaultLong: PropTypes.number,
  lines: PropTypes.array,
  circles: PropTypes.array,
  polygons: PropTypes.array,
  vbuoys: PropTypes.array,
  geojsons: PropTypes.array
};
